module.exports = __webpack_public_path__ + "img/398.33d9b1bf.jpg";